export function replaceAll(str: string, mapObj: any) {
  const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');

  return str.replace(re, (matched) => mapObj[matched]);
}
